import { AdminWidgetsItem } from "./AdminWidgetsItem";

export function AdminWidgets({ items }) {
  return (
    <div className="row">
      {items.map((item: any, i: number) => {
        return <AdminWidgetsItem item={item} key={i} />;
      })}
    </div>
  );
}
